import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
const Divider = function Divider({ prefixCls: customizePrefixCls, type = 'horizontal', orientation = '', className, children, dashed, ...restProps }) {
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('divider', customizePrefixCls);
    const orientationPrefix = orientation.length > 0 ? `-${orientation}` : orientation;
    const classString = classNames(className, prefixCls, `${prefixCls}-${type}`, {
        [`${prefixCls}-with-text${orientationPrefix}`]: children,
        [`${prefixCls}-dashed`]: !!dashed,
    });
    return (React.createElement("div", Object.assign({ className: classString }, restProps), children && React.createElement("span", { className: `${prefixCls}-inner-text` }, children)));
};
Divider.displayName = 'Divider';
export default memo(Divider);
